$(document).ready(function() {
  $(".regular").slick({
    dots: false,
    arrows: true,	
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 3,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }]
  })
});

jQuery(document).ready(function(){
  $(".menu_div").click(function(){ 
    $(".dimming").show();       
    $(".menubar").fadeIn(500);
    $(".drawer").hide();
  });
  $(".menu_icn").click(function(){
    $(".dimming").fadeOut();
    $(".menubar").fadeOut(600);
  });


  $(".glow-with-us").click(function(){  
    $(".menubar").fadeOut(600);      
    $(".dimming").show();       
    $(".glowwithus1").fadeIn(500);
  });
  $(".super_food_content_two .btn").click(function(){  
    $(".menubar").fadeOut(600);     
    $(".dimming").show();        
    $(".glowwithus1").fadeIn(500);
  });
});

function showcart(para) {
  if(para==1) {
    $(".dimming").show();
    $(".drawer").show();
  }
  if(para==2) {
    $(".dimming").fadeOut();
    $(".drawer").fadeOut();
  }

  $(".menubar").hide(); 
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

var city = getUrlParameter('city');
if(city!=null) {
  //alert(city);
  localStorage.setItem('city', city);
} else {
  //localStorage.setItem('city', 'Duncan');
}


$(document).ready(function() {
  var dialogShown = localStorage.getItem('city');

  if(dialogShown!=null) {
   	$('.stateyes').hide();
    
    if(dialogShown == 'Duncan') {
      $('.stateyes.state_duncan').show();
    }
    if(dialogShown == 'St.+Albert') {
      $('.stateyes.state_albert').show();
    }
    if(dialogShown == 'Red+Deer') {
      $('.stateyes.state_duncan').show();
    }
    if(dialogShown == 'Edmonton') {
      $('.stateyes.state_edmonton').show();
    }
    if(dialogShown == 'Hamilton') {
      $('.stateyes.state_hamilton').show();
    }
    if(dialogShown == 'Kelowna') {
      $('.stateyes.state_kelowna').show();
    }
    if(dialogShown == 'Leduc') {
      $('.stateyes.state_leduc').show();
    }
    if(dialogShown == 'Prince+Edward+Island') {
      $('.stateyes.state_prince-edward-island').show();
    }
    if(dialogShown == 'Red+Deer') {
      $('.stateyes.state_red-deer').show();
    }
    if(dialogShown == 'Sherwood+Park') {
      $('.stateyes.state_sherwood+park').show();
    }
    
    if($('.stateyes').css("display") == "none") {
    	$('.location-no-match').show();
    }
    
  	var dialogShowns = dialogShown.replace('+', ' ');    
  } else {
  	var dialogShowns = 'DUNCAN';
    
   	$('.stateyes').hide();
    
    if(dialogShowns == 'DUNCAN') {
      $('.stateyes.state_duncan').show();
    }
  }
  
  $("#locat").html(dialogShowns);

  //alert(dialogShown);

  if (dialogShown!=null) {
    $(".template-index .shopify-section").show();
    $(".glowwithus").hide();

    //$(".email_popup").fadeIn();
    //$('#bodyid').css({'overflow': 'hidden'});   
  }
  else {
    //$(".email_popup").hide();
  }  
});